// src/components/Project/coinflip/CoinflipCard.js
import React from 'react';
import './CoinflipCard.css';

const CoinflipCard = ({ flip }) => {
    const isWin = flip.result === flip.selected;
    const shortAddress = `${flip.player.slice(0, 6)}...${flip.player.slice(-4)}`;
    const resultEmoji = flip.result === 'Heads' ? '🙂' : '👑';
    const selectedEmoji = flip.selected === 'Heads' ? '🙂' : '👑';

    const totalWon = flip.totalWon ? parseFloat(flip.totalWon).toFixed(2) : null;

    return (
        <div className={`coinflip-card ${isWin ? 'coinflip-result-win' : 'coinflip-result-lose'}`}>
            <div>
                <p>
                    <strong>Player:</strong>{" "}
                    <a
                        href={`https://cronoscan.com/address/${flip.player}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {shortAddress}
                    </a>
                </p>
                <p><strong>Selected:</strong> {selectedEmoji} {flip.selected}</p>
                <p><strong>Result:</strong> {resultEmoji} {flip.result}</p>
                {totalWon && (
                    <p><strong>Winnings:</strong> {totalWon} CRO</p>
                )}
                <p style={{ fontSize: '0.85rem', color: '#aaa' }}>
                    {new Date(flip.createdAt).toLocaleString()}
                </p>
            </div>
            <div className={`coinflip-status ${isWin ? 'Win' : 'Lose'}`}>
                {isWin ? '✅ WIN' : '❌ LOOSE'}
            </div>
        </div>
    );
};

export default CoinflipCard;
